import { useLocation } from 'react-router-dom'
import { InstallPrompt } from '@/components/pwa/InstallPrompt'
import { UpdateNotification } from '@/components/pwa/UpdateNotification'
import { useInstallPrompt } from '@/pwa/use-install-prompt'
import { isInterruptiblePath } from '@/pwa/install-state'

interface PwaManagerProps {
  /** The install notification waits for a signed-in session. */
  isAuthenticated: boolean
}

/**
 * Owns both PWA notifications: "install StockWise" and "update available".
 *
 * Mounted once inside the router. It decides *whether* a card may appear
 * (signed in, not on the POS/checkout/payment routes) and leaves the timing
 * and per-device dismissal rules to `useInstallPrompt`.
 *
 * Order alerts are deliberately NOT offered here: that is a per-device
 * preference and lives in Settings (components/settings/DeviceNotifications).
 */
export function PwaManager({ isAuthenticated }: PwaManagerProps) {
  const location = useLocation()
  const allowed = isInterruptiblePath(location.pathname)

  const installState = useInstallPrompt({ enabled: isAuthenticated, allowed })

  return (
    <>
      <InstallPrompt state={installState} />
      {allowed && <UpdateNotification />}
    </>
  )
}

export default PwaManager
